if (!customElements.get('annoncement-component')) {
  customElements.define(
    'annoncement-component',
    class AnnoncementComponent extends HTMLElement {
      constructor() {
        super();
        document.addEventListener('DOMContentLoaded', function () {
          const container = this.querySelector('.annoncement_container');
          const wrapper = this.querySelector('.annoncement_container_wrapper');
          const items = this.querySelectorAll('.anoncement_item');
          const totalItems = items.length;
          let currentIndex = 0;

          function scrollToItem(index) {
            const itemWidth = container.offsetWidth;
            wrapper.scrollTo({
              left: index * itemWidth,
              behavior: 'smooth',
            });
          }

          function autoScroll() {
            currentIndex = (currentIndex + 1) % totalItems;
            scrollToItem(currentIndex);
          }

          setInterval(autoScroll, 3000);
        });
      }
    }
  );
}
